module.exports = __webpack_public_path__ + "static/media/profileCard.f9e90f6c.png";